// extracted by mini-css-extract-plugin
module.exports = {"controls":"CommentAdd_controls__1dBkd","field":"CommentAdd_field__2ylc5","content":"CommentAdd_content__3TyO0","user":"CommentAdd_user__1bvqO"};